import Vue from 'vue'
export const DISPLAY_NOTIFICATION = 'DISPLAY_NOTIFICATION'
export const DISPLAY_HUD_NOTIFICATION = 'DISPLAY_HUD_NOTIFICATION'

export default {
  actions: {
    [DISPLAY_NOTIFICATION]({ commit, state }, { type = 'info', title, message }) {
      if (!message) {
        console.error('Notification message is null')
        return false
      }

      if (message instanceof Error) {
        type = 'error'
        message = message.message || message
      }

      // Less scary message
      if (message.includes('internal error')) {
        // Should auto open the support widget
        message = 'Please contact support'
      }

      console.log('Notification:', message)
      Vue.notify({
        group: 'bottomright',
        type: `${type}-notif`,
        title: type || 'info',
        width: 400,
        text: message,
      })
    },
    [DISPLAY_HUD_NOTIFICATION]({ commit, state }, { type = 'info', message }) {
      console.log('HUD notification:', message)
      Vue.notify({
        group: 'topcenter',
        type: `${type}-notif`,
        width: '400px',
        title: type,
        text: message,
      })
    },
  },
}
